<script>
/* global L : true*/
import { OnTrainStationAdded, OnTrainStationClear } from './../../js/app_state'
import { TrainStation } from './../../js/train_stations'

const MARKER_MAX_WIDTH = 350;

export default {
    name: "TrainStationsMixin",

    data() {
        return {
            train_station_markers: [],
            current_train_station: new TrainStation(null, null, null),
        }
    },

    mounted() {
        OnTrainStationAdded.push((loc, name, info) => { this.onTrainStationAdded(loc, name, info); });
        OnTrainStationClear.push(() => { this.train_station_markers.forEach((ts_marker) => { ts_marker.remove(); }); });
    },

    methods: {
        onTrainStationAdded(train_station) {
            let train_icon = L.icon({iconUrl: 'train.png',
                                iconSize: [36, 36],
                        });
            let new_marker = L.marker(this.mymap.getCenter(), {icon: train_icon}).addTo(this.mymap);
            new_marker.setLatLng(L.latLng([train_station.localization[0], train_station.localization[1]]));
            this.train_station_markers.push(new_marker);

            new_marker.on('popupopen', () => {
                    this.current_train_station = train_station;
                    train_station.fetchNextDeparture();
            });

            this.current_train_station = train_station;
            // marker popup binding
            if (train_station.info.name !== "") {
                new_marker.bindPopup(()=>{return this.$refs.ts_dep.$el;}, { maxWidth: MARKER_MAX_WIDTH, 
                                                                            minWidth:MARKER_MAX_WIDTH});
            } else
                new_marker.bindPopup("No information available for this train station");  
                
        },
    },
}
</script>